import { defineFilterConfig, filterFieldAdapters } from "@src/components/business-form";
import type { StockActInvFilter } from "../../../../../../api/stockActInvs";

/** Значения формы фильтра списка АИ для полной инвентаризации склада. */
export interface StockFullInventoryFilterFormValues {
    /** Код склада АИ. */
    divisionCode: number | null;
    /** Номер АИ. */
    num: string;
    /** Коды статусов АИ. */
    stateCodes: number[];
}

/** Конфигурация фильтра списка АИ для полной инвентаризации склада. */
export const stockFullInventoryFilterFormConfig = defineFilterConfig<StockFullInventoryFilterFormValues, StockActInvFilter>({
    fields: {
        divisionCode: {
            type: "number",
            nullable: true,
            label: "Склад АИ",
            validation: { required: true },
            map: {
                from: (domain) => domain.DivisionCode ?? null,
                to: (value) => (value == null ? {} : { DivisionCode: value }),
            },
        },
        num: {
            type: "string",
            label: "Номер АИ",
            map: {
                from: (domain) => domain.NumMask ?? "",
                to: (value) => {
                    const trimmed = value.trim();
                    return { NumMask: trimmed === "" ? undefined : trimmed };
                },
            },
        },
        stateCodes: {
            type: "array",
            label: "Статусы АИ",
            map: filterFieldAdapters.entityCodes("StateCodes"),
        },
    },
});
